<template>
    <router-view :key="$router.fullPath"></router-view>
</template>

<script>
  export default {
    name: 'TopicLayout'
  };
</script>
